import dateAdmin from './dateAdmin'
import { WithProps } from './Format'

export { dateAdmin }
export { WithProps }
export function isUndefinedOrNull (variable) {
  return (variable === null || variable === undefined)
}
